import t from 'react-translate';
import { useEffect, useState } from 'react';
import { COUNTDOWN_DURATION_MS } from '../context';

// Kept in sync with the real audio-buffering delay. Rounded since a non-multiple
// of 1000 would otherwise produce fractional counts that never hit exactly 0.
const TOTAL_SECONDS = Math.round(COUNTDOWN_DURATION_MS / 1000);

const CountdownDisplay = () => {
  const [count, setCount] = useState(TOTAL_SECONDS);

  useEffect(() => {
    if (count <= 0) {
      return undefined;
    }
    const timer = setTimeout(() => setCount((prevCount) => prevCount - 1), 1000);
    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div className='d-flex'>
      <p className='mb-0 text-regular text-gray-1'>
        {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.RECORDING_STARTS()}
      </p>
      <p className='mb-0 text-regular text-gray-1 ml-1 font-weight-bolder'>{count}</p>
    </div>
  );
};

export default CountdownDisplay;
